import { SevenroomsVenueGroup as SevenroomsVenueGroupModel } from '@models/venue/integrations/SevenroomsAudience'
import { useAppSelector } from '@store/hooks'
import { selectSevenroomsVenueGroupById } from '@store/venue/integrations/SevenroomsVenueGroupReducer'
import { SBModelComponent } from '@supplement-bacon/react-toolkit/models'
import { Space } from 'antd'
import { FC } from 'react'

type Props = SBModelComponent<SevenroomsVenueGroupModel> & {}

const SevenroomsVenueGroupOption: FC<Props> = ({ id, model }) => {
  const item = model ?? useAppSelector(selectSevenroomsVenueGroupById(id!))

  if (!item) {
    return <></>
  }

  return <Space>{item.name}</Space>
}

type SevenroomsVenueGroupOptionType = {
  Option: typeof SevenroomsVenueGroupOption
}

export { SevenroomsVenueGroupOption, type SevenroomsVenueGroupOptionType }
